module.exports = __webpack_public_path__ + "img/1.2e41c996.png";